module.exports = __webpack_public_path__ + "img/thumbnail_LOGO - Seed 2.7fde0647.png";